export const layoutKey = "carPro.layoutKey";
export const schemeKey = "carPro.schemeKey";
export const themeKey = "carpro.themeKey"